import { render, staticRenderFns } from "./merchantManage.vue?vue&type=template&id=a0afccb6&scoped=true&"
import script from "./merchantManage.vue?vue&type=script&lang=js&"
export * from "./merchantManage.vue?vue&type=script&lang=js&"
import style0 from "./merchantManage.vue?vue&type=style&index=0&id=a0afccb6&lang=scss&scoped=true&"
import style1 from "./merchantManage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0afccb6",
  null
  
)

export default component.exports